import { gql } from '@apollo/client';

export const QUERY_MY_DOWNLOAD_USAGE = gql`
  query MyDownloadUsage {
    myDownloadUsage {
      used
      limit
      remaining
      periodStart
      periodEnd
    }
  }
`;
